import styled from 'styled-components';

interface ModalBodyProps {
  $resize?: string;
  $paddingModal?: string;
  $display?: string;
}

export const ModalBackground = styled.div`
  background-color: white;
  background-image: unset;
  height: -webkit-fill-available;
  height: -moz-available;
  height: fill-available;
  height: 100%;
  min-height: auto;
  width: 100%;
  position: fixed;
  @media (min-width: 500px) {
    /* position: fixed; */
    background-color: unset;
    background-image: url('background-image-red2.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: auto;
  }
`;

export const ModalContainer = styled.div<ModalBodyProps>`
  width: 100%;
  height: 100%;
  min-height: auto;
  position: relative;
  background-color: #fff;
  overflow-x: hidden;
  overflow-y: auto;
  display: ${(props) => (props.$display ? props.$display : 'block')};
  flex-direction: column;
  @media (min-width: 500px) {
    max-width: 453px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 50px;
    height: auto;
    min-height: 625px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const ModalBody = styled.div<ModalBodyProps>`
  width: 100%;
  min-height: calc(100% - 125px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  padding-right: ${(props) => (props.$paddingModal ? props.$paddingModal : '2.5rem')};
  padding-left: ${(props) => (props.$paddingModal ? props.$paddingModal : '2.5rem')};
  background: white;
  @media (max-width: 450px) {
    padding-right: ${(props) => (props.$resize === 'true' ? '' : '1rem')};
    padding-left: ${(props) => (props.$resize === 'true' ? '' : '1rem')};
    /* height: auto; */
  }
  @media (max-width: 500px) {
    position: relative;
    /* height: auto; */
  }
`;
